import React from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/yellowcalfcss/ViewBill.css';

export default function ViewBill() {
  const billDetails = {
    billNo: 'wwxxzz',
    supplier: 'New supplier',
    date: '03 Apr 2024',
    dueDate: '2024-04-14',
    items: [
      { name: 'book', quantity: 2, unitPrice: 45 },
      { name: 'pen', quantity: 2, unitPrice: 10 },
      { name: 'bag', quantity: 1, unitPrice: 450 }
    ]
  };

  const calculateItemTotal = (item) => item.quantity * item.unitPrice;
  const totalAmount = billDetails.items.reduce((sum, item) => sum + calculateItemTotal(item), 0);

  const handlePrint = () => window.print();
  const handleEdit = () => alert('Edited Successfully');
  const handleDelete = () => alert('Deleted Successfully');

  return (
    <div className="bill-wrapper">
      <Container fluid className="bill-main-container">
        <div className="top-section">
          <div className="top-section-inner">
            <h3>View Bills</h3>
            <div className="actions-group">
             
              <Button className="primary-btn" onClick={handlePrint}>
                Print
              </Button>
              <Button className="primary-btn" onClick={handleEdit}>
                Edit
              </Button>
              <Button className="primary-btn delete-btn-custom" onClick={handleDelete}>
                Delete
              </Button>
            </div>
          </div>
        </div>

        <div className="location-section">
          <p className="location-text">Sharjah - United Arab Emirates, 9446836724, newschool@mailinator.com</p>
        </div>

        <div className="bill-info-section">
          <div className="bill-info-layout">
            <div className="info-box">
              <strong>Bill No:</strong> {billDetails.billNo}
            </div>
            <div className="info-box">
              <strong>Supplier:</strong> {billDetails.supplier}
            </div>
            <div className="info-box">
              <strong>Date:</strong> {billDetails.date}
            </div>
            <div className="info-box">
              <strong>Due Date:</strong> {billDetails.dueDate}
            </div>
          </div>
        </div>

        <div className="items-header">
          <div className="items-header-layout">
            <div className="header-col-num">#</div>
            <div className="header-col-name">Items</div>
            <div className="header-col-qty">Quantity</div>
            <div className="header-col-price">Unit Price</div>
            <div className="header-col-amount">Item Total</div>
          </div>
        </div>

        <div className="items-list">
          {billDetails.items.map((item, index) => (
            <div key={index} className="item-single-row">
              <div className="items-header-layout">
                <div className="header-col-num">{index + 1}</div>
                <div className="header-col-name">{item.name}</div>
                <div className="header-col-qty">{item.quantity}</div>
                <div className="header-col-price">${item.unitPrice}</div>
                <div className="header-col-amount">${calculateItemTotal(item)}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="summary-section">
          <div className="summary-inner">
            <strong>Total Bill Amount</strong>
            <strong>${totalAmount}</strong>
          </div>
        </div>
      </Container>
    </div>
  );
}
